const apiPrefix = window.basicData.apiPrefix
// 用于存放处理后的接口地址
let modules = {}

// api地址
const api = {
  // 首页
  home: {
    getConfig: '/api/v1/home/get-config', // 查询配置
    getRankList: '/api/v1/point/get-list', // 获取学霸榜列表
    getUserRank: '/api/v1/point/get-detail' // 获取用户自身学霸榜排名信息
  },
  // 课程
  course: {
    list: '/api/v1/course/get-list',  // 课程列表
    detail: '/api/v1/course/get-detail',  // 课程详情
    catalog: '/api/v1/course/get-catalog',  // 目录
    consultant: '/api/v1/course/get-consultant',  // 课程顾问
    appointList: '/api/v1/course/get-appoint-list', // 约课列表
    userCourse: '/api/v1/course/user-course',    // 用户课程查询
    courseAppoint: '/api/v1/course/get-course-appoint',  // 用户预约接口
    advancedCourse: '/api/v1/course/advanced-course',    // 分级课程列表查询
    addLearningHistory: '/api/v1/common/add-learning-history'     // 用户学习历史新增
  },
  // 公共
  common: {
    managerTicketLogin: '/api/v1/user/ticket-login', // 股掌柜内嵌登录换令牌
    managerLogoutLogin: '/api/v1/user/logout-login', // 股掌柜内嵌退出登陆
    getBanner: '/api/v1/common/get-banner', // 获取轮播图
    getNotice: '/api/v1/common/get-notice',  // 获取公告列表
    verifyMobile: '/api/v1/user/verify-mobile',   // 是否有绑电话
    editMobile: '/api/v1/user/register-moblie',   // 用户绑定手机号注册
    collect: '/api/v1/common/collect', // 埋点
    dictionary: '/api/v1/common/qry-dict', // 数据字典查询
    statistics: '/api/v1/course/mod-num', // 客户端人数统计
    wxconfig: '/api/v1/common/jssdk-config' // wx-jssdk验证
  },
  // 学习
  study: {
    historyList: '/api/v1/common/get-learning-history',    // 用户学习历史查询
    clearHistory: '/api/v1/course/clear-history',   // 清空历史列表
    userBuyCourseLists: '/api/v1/course/user-course-and-histories'  // 已购买模块接口
  },
  // 用户
  user: {
    getInfo: '/api/v1/user/get-info', // 个人信息查询
    getAuthCode: '/api/v1/user/get-auth-code', // 短信码
    certification: '/api/v1/user/certification', // 实名验证
    updateMobile: '/api/v1/user/update-mobile', // 修改绑定手机号
    updateInfo: '/api/v1/user/update-info', // 修改用户信息
    uploadAvatar: '/api/v1/user/upload-avatar', // 上传用户头像
    updateAvatar: '/api/v1/user/update-avatar', // 修改用户头像
    msgList: '/api/v1/msg/get-list',   // 消息中心列表查询
    orderList: '/api/v1/user/order-user-course' // 用户订单查询
  },
  // 投顾
  invest: {
    getAdviser: '/api/v1/adviser/get-adviser', // 专家团查询
    aiLiveList: '/api/v1/ai-live/list',  // AI智投直播列表
    columnsList: '/api/v1/articles-must-read/list', // 专栏列表数据
    columnsDetail: '/api/v1/articles-must-read/detail', // 专栏详情
    columnIncReade: '/api/v1/articles-must-read/inc-read', // 专栏详情阅读添加
    columnSubscribe: '/api/v1/special/get-column-detail',  // 查看是否订阅专栏和老师详情(是否订阅和专家团查询合并成一个接口)
    columnSubscribeStatus: '/api/v1/special/get-column', // 查看是否订阅专栏
    columnSubscribeAdd: '/api/v1/special/add-column', // 专栏订阅
    columnSubscribeClose: '/api/v1/special/close-column' // 专栏取消
  },
  // 直播
  live: {
    liveDetail: '/api/v1/course/get-list-by-live',
    list: '/api/v1/course/get-list',   // 课程列表查询（同course.list）
    userHistoryList: '/api/v1/course/user-course', // 用户课程查询（同course.userCourse）
    getDynamicList: '/api/v1/msg/qry-news-feed',     // 获取动态轮播数据
    courseConsultant: '/api/v1/course/get-consultant',     // 课程顾问查询(同course.consultant)
    yunUserInfo: '/api/v1/msg/yunxin-account',  // [云信]获取用户信息
    chatroomAdress: '/api/v1/msg/chat-room-addr',  // [云信]获取聊天室地址
    liveStatus: '/api/v1/course/get-live-info',    // 直播状态查询
    userConsultant: '/api/v1/course/get-user-consultant',    // 用户课程顾问查询
    advancedCourse: '/api/v1/course/advanced-course',    // 分级课程列表查询(同course.advancedCourse)
    examineHdMsg: '/api/v1/common/add-yunxin-message'    //  互动用户消息录入审核
  },
  // 搜索
  search: {
    historyList: '/api/v1/search/search-history',  // 用户搜索历史列表
    addSearch: '/api/v1/search/add-search',        // 新增用户搜索历史
    searchList: '/api/v1/search/search-list',      // 搜索结果列表
    searchDetail: '/api/v1/search/search-detail',  // 搜索结果详情
    hotSearch: '/api/v1/search/hot-search'         // 热门搜索标签列表
  },
  // app页面请求地址
  appUrl: {
    getInvestAdviser: '/app-api/v1/adviser/get-adviser', // 专家团查询(同invest.getAdviser)
    getRankList: '/app-api/v1/point/get-list', // 获取学霸榜列表(home.getRankList)
    getUserRank: '/app-api/v1/point/get-detail', // 获取用户自身学霸榜排名信息(home.getUserRank)
    courseList: '/app-api/v1/course/get-list', // 课程列表（同course.list)
    userCertification: '/app-api/v1/user/certification', // 实名验证（同user.certification)
    msgList: '/app-api/v1/msg/get-list', // 消息中心列表查询(同user.msgList)
    getNotice: '/app-api/v1/common/get-notice',  // 获取公告列表(同common.getNotice)
    collect: '/app-api/v1/common/collect' // 埋点(同common.collect)
  }
}

// 添加前缀函数
const addUrlPrefix = (module, obj, prefix) => {
  for (let key in obj) {
    let value = obj[key]
    if (typeof value === 'object') {
      if (modules[key] === undefined) {
        modules[key] = {}
      }
      addUrlPrefix(key, value, prefix)
    } else {
      let nvalue = '/investor-education-manager' + value
      if (module !== '' && nvalue.indexOf('http') === -1) {
        modules[module][key] = prefix.concat(nvalue)
      } else if (module === '' && nvalue.indexOf('http') === -1) {
        modules[key] = prefix.concat(nvalue)
      } else if (module !== '' && nvalue.indexOf('http') !== -1) {
        modules[module][key] = nvalue
      }
    }
  }
}

addUrlPrefix('', api, apiPrefix)

export default modules



// WEBPACK FOOTER //
// ./src/fetch/resource.js